import { useRenewBookingFormContext } from "./RenewBookingFormContext";

const useRenewBookingForm = () => {
    const {
        isRenewBooking,
        rebookingFormRef,
        renewBookingFormDetails,
        setRenewBookingFormDetails,
        billingStateNonMandatory,
        showGstOption,
        isGstChecked,
        handleGstCheck,
        renewBookingBaseFormFields,
        renewBookingGstFormFields,
    } = useRenewBookingFormContext();

    return {
        hideComponent: !isRenewBooking,
        rebookingFormRef,
        renewBookingFormDetails,
        setRenewBookingFormDetails,
        billingStateNonMandatory,
        showGstOption,
        isGstChecked,
        handleGstCheck,
        renewBookingBaseFormFields,
        renewBookingGstFormFields,
    };
};

export default useRenewBookingForm;
